import React from 'react';
import Page from 'components/page/Page';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Button } from 'common.ui';
import { useTranslation } from 'react-i18next';

interface IProps {
  onLogin: () => void;
}

export const ProfileValidationCancelled = ({ onLogin }: IProps) => {
  const { t } = useTranslation('components');
  return (
    <Page
      header={t('profileValidate.profileValidationCancelled.title')}
      title={t('profileValidate.profileValidationCancelled.title')}
    >
      <Container fluid>
        <Row>
          <Col sm={12} lg={6}>
            <p>{t('profileValidate.profileValidationCancelled.text')} </p>
            <Button showArrow text={t('profileValidate.profileValidationCancelled.tryAgain')} onClick={onLogin} />
          </Col>
        </Row>
      </Container>
    </Page>
  );
};
